'use strict';

var _asyncToGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _regeneratorRuntime = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var errCode = require('err-code');

var extractDataFromBlock = require('../utils/extract-data-from-block');

var validateOffsetAndLength = require('../utils/validate-offset-and-length');

var mh = require('multihashing-async').multihash;

var rawContent = function rawContent(node) {
  return /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var options,
        _validateOffsetAndLen,
        offset,
        length,
        _args = arguments;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            options = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
            _validateOffsetAndLen = validateOffsetAndLength(node.length, options.offset, options.length), offset = _validateOffsetAndLen.offset, length = _validateOffsetAndLen.length;
            _context.next = 4;
            return extractDataFromBlock(node, 0, offset, offset + length);

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  });
};

var resolve = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(cid, name, path, toResolve, _resolve, depth, ipld, options) {
    var buf;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (!toResolve.length) {
              _context2.next = 2;
              break;
            }

            throw errCode(new Error("No link named ".concat(path, " found in raw node ").concat(cid.toBaseEncodedString())), 'ERR_NOT_FOUND');

          case 2:
            _context2.next = 4;
            return mh.decode(cid.multihash);

          case 4:
            buf = _context2.sent;
            return _context2.abrupt("return", {
              entry: {
                name: name,
                path: path,
                cid: cid,
                node: buf,
                content: rawContent(buf.digest),
                depth: depth
              }
            });

          case 6:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function resolve(_x, _x2, _x3, _x4, _x5, _x6, _x7, _x8) {
    return _ref.apply(this, arguments);
  };
}();

module.exports = resolve;